/* eslint-disable react/no-danger */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledMasthead = styled.div`
  position: relative;
  margin-bottom: 28px;
  .band {
    width: 100%;
    height: 3px;
    background: #ffcc00;
    margin: 20px auto;
  }
  img {
    max-width: 100%;
    @media all and (max-width: 700px){
      width: 100%;
    }
  }
  .copy {
    position: absolute;
    bottom: 40px;
    left: 0;
    width: 100%;
    z-index: 2;
    text-align: center;
    @media all and (max-width: 700px) {
      bottom: 20px;
    }
    h1,
    p {
      color: #fff;
      margin: 0;
      padding: 0;
      font-weight: bold;
      line-height: 1;
    }
    h1 {
      font-size: 30px;
      @media all and (max-width: 700px) {
        font-size: 18px;
      }
    }
    p {
      font-size: 18px;
      margin-top: 12px;
      @media all and (max-width: 700px) {
        font-size: 10px;
        margin-top: 8px;
      }
      a {
        color: #facd22;
      }
    }
  }
`;

const Masthead = ({ imgPrefix, submitted, copy }) => (
  <StyledMasthead>
    <div className="band" />
    {!submitted && <img alt="logo" src={`${imgPrefix}/images/masthead.png`} />}
    {submitted && (
      <img alt="logo" src={`${imgPrefix}/images/masthead_thanks.png`} />
    )}
    <div className="copy">
      {!submitted ? (
        <h1>{copy.masthead.title}</h1>
      ) : (
        <h1>{copy.masthead.thankstitle}</h1>
      )}
      {!submitted ? (
        <p dangerouslySetInnerHTML={{ __html: copy.masthead.subtitle }} />
      ) : (
        <p dangerouslySetInnerHTML={{ __html: copy.masthead.thankssubtitle }} />
      )}
    </div>
  </StyledMasthead>
);

Masthead.defaultProps = {
  submitted: false,
};

Masthead.propTypes = {
  submitted: PropTypes.bool,
  imgPrefix: PropTypes.string.isRequired,
  copy: PropTypes.objectOf(PropTypes.object).isRequired,
};
export default Masthead;
